import { generateRequest } from '.';

export const Action = {
  Vehicle: {
    FetchMakesPending: 'FetchMakes_PENDING',
    FetchMakesCompleted: 'FetchMakes_FULFILLED',
    FetchMakesFailed: 'FetchMakes_FAILED',
    FetchModelsPending: 'FetchModels_PENDING',
    FetchModelsCompleted: 'FetchModels_FULFILLED',
    FetchModelsFailed: 'FetchModels_FAILED',
    FetchVehicleRecallSearchResultsPending: 'FetchVehicleRecallSearchResults_PENDING',
    FetchVehicleRecallSearchResultsCompleted: 'FetchVehicleRecallSearchResults_FULFILLED',
    FetchVehicleRecallSearchResultsFailed: 'FetchVehicleRecallSearchResults_FAILED',
    FetchVehiclesPending: 'FetchVehicles_PENDING',
    FetchVehiclesCompleted: 'FetchVehicles_COMPLETED',
    FetchVehiclesFailed: 'FetchVehicles_FAILED',
    FetchUserVehicleRecallsPending: 'FetchUserVehicleRecalls_PENDING',
    FetchUserVehicleRecallsCompleted: 'FetchUserVehicleRecalls_FULFILLED',
    FetchUserVehicleRecallsFailed: 'FetchUserVehicleRecalls_FAILED',
    DismissUserVehicleRecallPending: 'DismissUserVehicleRecall_PENDING',
    DismissUserVehicleRecallCompleted: 'DismissUserVehicleRecall_FULFILLED',
    DismissUserVehicleRecallFailed: 'DismissUserVehicleRecall_FAILED',
  },
  MemberInfo: {
    VehicleCountPending: 'VehicleCount_PENDING',
    VehicleCountCompleted: 'VehicleCount_FULFILLED',
    VehicleCountFailed: 'VehicleCount_FAILED',
  },
};

export const fetchVehicleRecallsByYearMakeAndModel = (year, make, model) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/recalls/${year}/${make}/${model}`,
  types: [
    Action.Vehicle.FetchVehicleRecallSearchResultsPending,
    Action.Vehicle.FetchVehicleRecallSearchResultsCompleted,
    Action.Vehicle.FetchVehicleRecallSearchResultsFailed,
  ],
});

export const fetchVehicles = () => generateRequest({
  endpoint: '/assets-v2/api/vehicles',
  types: [
    Action.Vehicle.FetchVehiclesPending,
    Action.Vehicle.FetchVehiclesCompleted,
    Action.Vehicle.FetchVehiclesFailed,
  ],
});

export const fetchRecallsForUserVehicle = vehicleGuid => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/recalls`,
  types: [
    Action.Vehicle.FetchUserVehicleRecallsPending,
    Action.Vehicle.FetchUserVehicleRecallsCompleted,
    Action.Vehicle.FetchUserVehicleRecallsFailed,
  ],
});

export const dismissRecallForUserVehicle = (vehicleGuid, recallId) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/recalls/${recallId}`,
  method: 'PATCH',
  credentials: 'same-origin',
  body: {
    status: 'dismissed',
  },
  types: [
    Action.Vehicle.DismissUserVehicleRecallPending,
    Action.Vehicle.DismissUserVehicleRecallCompleted,
    Action.Vehicle.DismissUserVehicleRecallFailed,
  ],
});

export const countUserVehicles = () => generateRequest({
  endpoint: '/assets-v2/api/vehicles/count',
  types: [
    Action.MemberInfo.VehicleCountPending,
    Action.MemberInfo.VehicleCountCompleted,
    Action.MemberInfo.VehicleCountFailed,
  ],
});
